import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAzelaicAcidGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m26.18 21.481-1.234.508-1.016-1.076-2.31.956.05 1.484-1.234.508-.16-6.731 1.255-.518 4.65 4.869Zm-4.68-2.858.06 2.101 1.594-.657-1.434-1.533-.239-.279.02.369ZM32.164 19.012l-1.234.508-1.016-1.086-2.31.956.05 1.484-1.235.508-.159-6.731 1.255-.518 4.65 4.879Zm-4.67-2.868.06 2.101 1.594-.657-1.444-1.533-.24-.279.03.368ZM23.462 29.575l-3.488 3.105.828.93 3.487-3.106-.827-.93Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M19.709 40 8 28.291l4.291-16.01 16-4.281L40 19.709l-4.291 16-16 4.291ZM9.384 27.913l10.693 10.693 14.606-3.913 3.913-14.606L27.913 9.384l-14.606 3.923-3.923 14.606Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m15.382 24.556-.754.99 3.716 2.827.754-.99-3.716-2.827ZM27.281 25.764l-.753.99 3.716 2.828.753-.99-3.716-2.828Z",
    fill: "currentColor"
  }));
}

export { SvgAzelaicAcidGlyph as default };
